import React, { memo, useEffect, useRef, useState } from 'react'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import Paper from '@mui/material/Paper'
import List from '@mui/material/List'
import {
  Calendar,
  GoogleDocs,
  HomeAltSlimHoriz,
  MenuScale,
  MultiplePagesEmpty,
  MultiplePages,
} from 'iconoir-react'
import { useLocation, useNavigate } from 'react-router-dom'
// firebase
import 'firebase/messaging'
// Other
import { inject, observer } from 'mobx-react'
import { vapidKey } from '../config'

import { defaultMessaging } from '../firebase'
import { getMessaging, getToken } from 'firebase/messaging'
import {
  ACL_ACTION_TYPE,
  MODULE_CODE,
  VAN_PHONG_DIEN_TU,
} from '../utils/constants'
import Message from '../components/common/Message'
import { Button, useTheme } from '@mui/material'
import Drawers from './MainDrawer'
import { ignoreFirebase } from '../config'

const ItemMenu = ({ children }) => (
  <div className="relative text-sm font-bold after:absolute after:w-12 after:h-12 after:bg-[rgba(0,115,199,0.07)] after:rounded-full   ">
    {children}
  </div>
)

const sortCommands = (a, b) => {
  const nameA = a.name.toUpperCase()
  const nameB = b.name.toUpperCase()
  let comparison = 0
  if (nameA > nameB) {
    comparison = 1
  } else if (nameA < nameB) {
    comparison = -1
  }
  return comparison
}
const MainLayout = ({
  initialValue,
  children,
  notificationStore,
  authenticationStore,
  moduleStore,
  aclStore,
  accountStore,
  commandStore,
  styleDrawer,
  proposalStore,
}) => {
  //drawer state
  const [openDrawer, setOpenDrawer] = useState(false)
  let messaging
  if (!ignoreFirebase) {
    messaging = getMessaging() || defaultMessaging
  }
  const theme = useTheme()
  useEffect(() => {
    if (!localStorage.getItem('FCMToken') && !ignoreFirebase) {
      getToken(messaging, { vapidKey: vapidKey })
        .then(currentToken => {
          if (currentToken) {
            localStorage.setItem('FCMToken', JSON.stringify(currentToken))
            notificationStore
              .sendTokenToSever(currentToken)
              .then(res => {
                // console.log(res)
              })
              .catch(err => {
                // console.log(err.vi)
              })
          } else {
            // console.log(
            //   'No registration token available. Request permission to generate one.'
            // )
          }
        })
        .catch(() => {
          // console.log('You have blocked notifications!')
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [value, setValue] = React.useState(initialValue)
  const ref = React.useRef(null)
  const navigate = useNavigate()
  const location = useLocation()
  const resetTab = () => {
    switch (location.pathname) {
      case '/':
        return setValue(0)
      case '/company-work-schedule':
        return setValue(1)
      case '/internal-document/incoming-document':
        return setValue(2)
      case '/work':
        return setValue(3)
      case '/proposal':
        return setValue(4)
      default:
        return navigate('#')
    }
  }

  // ALC & Module
  const { currentUser, isAccountAdmin, isSuperAdmin } = authenticationStore
  const { aclActionsByUser } = aclStore
  const [message, setMessage] = useState({ isOpen: false })
  const { accountList } = accountStore
  const { commandList } = commandStore

  const isCurrentUserHasCommand =
    currentUser?.commands && currentUser.commands.length !== 0

  useEffect(() => {
    if (isCurrentUserHasCommand) {
      currentUser.commands.forEach(userCommand => {
        commandList.length !== 0 &&
          commandList.forEach(command => {
            if (command.code === userCommand.code) {
              userCommand.url = command.url
              userCommand.description = command.description
              userCommand.image = command.image
            }
          })
        accountList.length !== 0 &&
          accountList.forEach(account => {
            if (account.command.code === userCommand.code) {
              userCommand.account_name = account.account_name
              userCommand.id = account.id
              userCommand.password = account.password
            }
          })
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, commandList, accountList, isCurrentUserHasCommand])

  const isAccessControl = (moduleCode, accessControlType) => {
    if (isSuperAdmin) return true
    if (!moduleStore.checkAccessModule(moduleCode)) return false
    if (accessControlType)
      return (
        isAccountAdmin ||
        !!aclActionsByUser.find(item => item.code === accessControlType)?.status
      )
    return true
  }

  const handleChangeTab = (event, newValue) => {
    setValue(newValue)
    switch (newValue) {
      case 0:
        return navigate('/')
      case 1:
        if (
          isAccessControl(
            MODULE_CODE.lich_co_quan,
            ACL_ACTION_TYPE.menu__WORK_SCHEDULE
          )
        ) {
          return navigate('/company-work-schedule')
        }
        setMessage({ isOpen: true, severity: 'error' })
        resetTab()
        return false
      case 2:
        if (
          isAccessControl(MODULE_CODE.van_ban) &&
          isCurrentUserHasCommand &&
          currentUser.commands
            .slice()
            .sort(sortCommands)
            .some(item => item.code === VAN_PHONG_DIEN_TU) &&
          isAccessControl(
            MODULE_CODE.van_ban_noi_bo,
            ACL_ACTION_TYPE.menu__INTERNAL_DOCUMENT
          )
        ) {
          if (
            aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.tab_vb_den__INTERNAL_DOCUMENT
            )
          )
            return navigate('/internal-document/incoming-document')
          if (
            aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.tab_vb_di__INTERNAL_DOCUMENT
            )
          )
            return navigate('/internal-document/outgoing-document')
        }
        setMessage({ isOpen: true, severity: 'error' })
        resetTab()
        return false
      case 3:
        if (
          isAccessControl(MODULE_CODE.cong_viec, ACL_ACTION_TYPE.menu__WORK)
        ) {
          return navigate('/work')
        }
        setMessage({ isOpen: true, severity: 'error' })
        resetTab()
        return false

      case 4:
        if (
          isAccessControl(
            MODULE_CODE.hanh_chinh,
            ACL_ACTION_TYPE.menu__PROPOSAL_ADVANCE
          )
        ) {
          return navigate('/proposal')
        }
        setMessage({ isOpen: true, severity: 'error' })
        resetTab()
        return false
      case 5:
        if (
          isAccessControl(MODULE_CODE.duyet_luong, ACL_ACTION_TYPE.menu__SALARY)
        ) {
          return navigate('/proposal-salary-request')
        }
        setMessage({ isOpen: true, severity: 'error' })
        resetTab()
        return false
      default:
        return navigate('#')
    }
  }
  // const myRef = useRef(null)

  // useEffect(() => {
  //   const myDiv = myRef.current
  //   myDiv.addEventListener(
  //     'touchmove',
  //     function (event) {
  //       event = event.originalEvent || event
  //       if (event.scale !== 1) {
  //         event.preventDefault()
  //       }
  //     },
  //     false
  //   )
  // }, [])
  return (
    <div>
      <Box
        sx={{
          '& .MuiButtonBase-root.MuiBottomNavigationAction-root.Mui-selected': {
            margin: 'auto 10px',
            maxHeight: '40px !important',
            minHeight: '40px !important',
            maxWidth: '40px !important',
            minWidth: '40px !important',
            backgroundColor: 'rgba(0,115,199,0.07) !important',
            borderRadius: '50% !important',
          },
          '& MuiTab-root.Mui-selected': {
            borderRadius: '10px !important',
          },
        }}
        ref={ref}>
        <CssBaseline />
        <List>
          <div className=" pb-14">{children}</div>
        </List>

        <Paper
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            marginX: 'auto',
          }}
          elevation={3}
          className="border-none shadow-none rounded-t-[30px]">
          <BottomNavigation
            showLabels
            value={value}
            onChange={handleChangeTab}
            className="min-h-[96px] rounded-t-[10px] shadow-[0px_-2px_12px_rgba(192,188,188,0.4)]">
            <BottomNavigationAction
              className="p-0  whitespace-nowrap"
              label={
                value === 0 ? (
                  // <ItemMenu>
                  <HomeAltSlimHoriz color="#2c65ac" />
                ) : (
                  // </ItemMenu>
                  'Trang chủ'
                )
              }
              icon={value === 0 ? '' : <HomeAltSlimHoriz color="black" />}
            />
            <BottomNavigationAction
              className="p-0 whitespace-nowrap bg-red-[400]"
              label={
                value === 1 ? (
                  // <ItemMenu>
                  <Calendar color="#2c65ac" />
                ) : (
                  // </ItemMenu>
                  'Lịch cơ quan'
                )
              }
              icon={value === 1 ? '' : <Calendar color="black" />}
            />
            <BottomNavigationAction
              className="p-0 whitespace-nowrap"
              label={
                value === 2 ? (
                  // <ItemMenu>
                  <GoogleDocs color="#2c65ac" />
                ) : (
                  // </ItemMenu>
                  'VBNB'
                )
              }
              icon={value === 2 ? '' : <GoogleDocs color="black" />}
            />
            <BottomNavigationAction
              className="p-0 whitespace-nowrap"
              label={
                value === 3 ? (
                  // <ItemMenu>
                  <MultiplePagesEmpty color="#2c65ac" />
                ) : (
                  // </ItemMenu>
                  'Công việc'
                )
              }
              icon={value === 3 ? '' : <MultiplePagesEmpty color="black" />}
            />
            <BottomNavigationAction
              className="p-0  whitespace-nowrap"
              label={
                value === 4 ? (
                  // <ItemMenu>
                  <div className="">
                    <MultiplePages color="#2c65ac" />
                  </div>
                ) : (
                  // </ItemMenu>
                  'Hành chính'
                )
              }
              icon={value === 4 ? '' : <MultiplePages color="black" />}
            />
          </BottomNavigation>
        </Paper>
        {styleDrawer === false ? (
          <div
            style={{
              position: 'absolute',
              top: 0,
              borderRadius: '50%',
              color: theme.color.text2,
              borderRadius: '10px',
            }}
            className="border-none shadow-none items-center pt-[20px] px-[20px] ">
            <span
              className="w-5 "
              onClick={() => {
                setOpenDrawer(true)
              }}>
              <MenuScale
                style={{
                  color: theme.color.primary,
                }}
              />
            </span>
          </div>
        ) : (
          <div
            style={{
              borderRadius: '50%',
              color: theme.color.text1,
            }}
            className="border-none shadow-none items-center p-[20px] fixed top-1 z-50">
            <span
              className="w-5 "
              onClick={() => {
                setOpenDrawer(true)
              }}>
              <MenuScale />
            </span>
          </div>
        )}
      </Box>
      <Drawers
        openDrawer={openDrawer}
        handleOpenDrawer={() => {
          setOpenDrawer(true)
        }}
        handleCloseDrawer={() => {
          setOpenDrawer(false)
        }}
      />
      <Message
        message={
          'Bạn không có quyền truy cập trang này, vui lòng liên hệ admin'
        }
        openMessage={message.isOpen}
        severity={message.severity}
        closeMessage={() => {
          setMessage({ isOpen: false })
        }}
      />
    </div>
  )
}

export default memo(
  inject(
    'notificationStore',
    'authenticationStore',
    'moduleStore',
    'aclStore',
    'accountStore',
    'commandStore',
    'proposalStore'
  )(observer(MainLayout))
)
